/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Channel_TrainerInputs */

const en_us2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer replies`)
};

const pt_br2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas do personal`)
};

const es_419_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas del entrenador`)
};

const pt_pt2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas do treinador`)
};

const fr_fr2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses du coach`)
};

const de_de2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten vom Coach`)
};

const it_it2_push_channel_trainer = /** @type {(inputs: Push_Channel_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte del coach`)
};

/**
* | output |
* | --- |
* | "Trainer replies" |
*
* @param {Push_Channel_TrainerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const push_channel_trainer = /** @type {((inputs?: Push_Channel_TrainerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Channel_TrainerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_push_channel_trainer(inputs)
	if (locale === "es-419") return es_419_push_channel_trainer(inputs)
	if (locale === "pt-PT") return pt_pt2_push_channel_trainer(inputs)
	if (locale === "fr-FR") return fr_fr2_push_channel_trainer(inputs)
	if (locale === "de-DE") return de_de2_push_channel_trainer(inputs)
	if (locale === "it-IT") return it_it2_push_channel_trainer(inputs)
	return en_us2_push_channel_trainer(inputs)
});
export { push_channel_trainer as "push.channel_trainer" }